import Vue from 'vue';
import Vuex from 'vuex';
import firebase from 'firebase';
import router from '@/router';
declare var ga: Function;
Vue.use(Vuex);
// https://medium.com/@oleg.agapov/basic-single-page-application-using-vue-js-and-firebase-part-2-143a3084266f
// https://savvyapps.com/blog/definitive-guide-building-web-app-vuejs-firebase
export default new Vuex.Store({
  state: {
    user: null,
    error: null,
    loading: false,
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
      if (payload) {
        ga('set', 'userId', payload.login.uid);
      }
    },
    setError(state, payload) {
      state.error = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
  },
  actions: {
    userSignIn({ commit }, payload) {
      commit('setLoading', true);
      firebase.auth().signInWithEmailAndPassword(payload.login, payload.password)
        .then((firebaseUser) => {
          commit('setUser', { login: firebaseUser.user });
          commit('setLoading', false);
          commit('setError', null);
          router.push('/');
        })
        .catch((error) => {
          commit('setError', error.message);
          commit('setLoading', false);
        });
    },
    autoSignIn({ commit }, payload) {
      commit('setUser', { login: payload });
    },
    userSignOut({ commit }) {
      firebase.auth().signOut().then(() => {
        commit('setUser', null);
        router.push('/login');
      });
    },
  }, getters: {
    isAuthenticated(state) {
      return state.user; // should do that lot !== null && state.user !== undefined;
    },
  },
});
